import { render, staticRenderFns } from "./DevicesTab.vue?vue&type=template&id=0f710870"
import script from "./DevicesTab.vue?vue&type=script&lang=js"
export * from "./DevicesTab.vue?vue&type=script&lang=js"
import style0 from "./DevicesTab.vue?vue&type=style&index=0&id=0f710870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports